import { render, staticRenderFns } from "./NewProjectModal.vue?vue&type=template&id=71977ae0&scoped=true"
import script from "./NewProjectModal.vue?vue&type=script&lang=ts"
export * from "./NewProjectModal.vue?vue&type=script&lang=ts"
import style0 from "./NewProjectModal.vue?vue&type=style&index=0&id=71977ae0&prod&lang=scss"
import style1 from "./NewProjectModal.vue?vue&type=style&index=1&id=71977ae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71977ae0",
  null
  
)

export default component.exports